<template>
	<div :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-500 wf-relative hover-trigger wf-pt-8 wf-pb-2 wf-px-2' : ''">
		<draggable
      class="wf-flex wf-w-full wf-flex-row wf-flex-wrap wf--mx-2"
      v-model="formColumns"
      group="formColumns"
      handle=".form-column-handle"
    >
      <div v-show="! previewMode" class="wf-absolute wf-z-50 wf-flex wf-top-0 wf-right-0 wf-mt-1 wf-mr-1 hover-target">
        <span class="wf-text-gray-600 wf-text-sm">form row</span>
        <div class="wf-relative wf-ml-4 wf-inline-block" @mouseover="showColumnsMenu = true" @mouseleave="showColumnsMenu = false">
          <button><i class="fas wf-text-sm wf-text-gray-500 hover:wf-text-gray-600 fa-columns"></i></button>
          <div class="wf-absolute wf-border wf-right-0 wf-w-32 wf-bg-white wf-rounded wf-shadow-md" v-show="showColumnsMenu">
            <ul>
              <li><button @click.prevent="updateColumns('COL_SIZE_1_1')" class="wf-p-2 hover:wf-bg-gray-100 wf-w-full wf-text-left wf-text-gray-600 hover:wf-text-gray-700 wf-text-xs">1 column</button></li>
              <li><button @click.prevent="updateColumns('COL_SIZE_1_2')" class="wf-p-2 hover:wf-bg-gray-100 wf-w-full wf-text-left wf-text-gray-600 hover:wf-text-gray-700 wf-text-xs">2 columns</button></li>
              <li><button @click.prevent="updateColumns('COL_SIZE_1_3')" class="wf-p-2 hover:wf-bg-gray-100 wf-w-full wf-text-left wf-text-gray-600 hover:wf-text-gray-700 wf-text-xs">3 columns</button></li>
              <li><button @click.prevent="updateColumns('COL_SIZE_1_4')" class="wf-p-2 hover:wf-bg-gray-100 wf-w-full wf-text-left wf-text-gray-600 hover:wf-text-gray-700 wf-text-xs">4 columns</button></li>
            </ul>
          </div>
        </div>
        <button v-show="parent.formRows.length > 1" class="wf-ml-4" @click.prevent="removeRow"><i class="fas wf-text-sm wf-text-gray-500 hover:wf-text-gray-600 fa-trash"></i></button>
        <button class="wf-ml-4 form-row-handle"><i class="fas wf-text-sm wf-text-gray-500 hover:wf-text-gray-600 fa-arrows-alt"></i></button>
      </div>
      <EditorFormColumn v-for="formColumn in formColumns" :key="formColumn.id" :parentModule="parentModule"/>
    </draggable>
	</div>
</template>

<script>
  import draggable from 'vuedraggable'
	import EditorFormColumn from './EditorFormColumn'
	import FormColumnWidths from '../mixins/FormColumnWidths'
  import ArrayManipulation from '../mixins/ArrayManipulation'
  import { FormColumnFactory } from '../factories/FormColumnFactory'
  export default {
    props: {
      parentModule: {
        type: String,
        required: false
      }
    },
    mixins: [ArrayManipulation, FormColumnWidths],
		components: {draggable, EditorFormColumn},
    data() {
      return {
        showColumnsMenu: false
      }
    },
    computed: {
      previewMode() {
        return this.$store.state.previewMode
      },
      id() {
        return this.$vnode.key
      },
      device() {
        return this.parent.device
      },
      parent() {
        return this.$parent.$parent
      },
      formElement() {
        return this.parent.element
      },
      module() {
        return this.parent.module
      },
      form() {
        return this.$store.getters[`${this.module}/elements`](this.formElement, this.parentModule)
      },
      formColumns:{
        get() {
          return this.parent.formRows.find(formRow => formRow.id === this.id).columns
        },
        set(value) {
          let element = Array.from(this.parent.formRows).map(formRow => {
            if (formRow.id != this.id){
              return formRow
            }
            return {...formRow, columns: value}
          })
          this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
        }
      },
    },
    methods: {
      updateColumns(size) {
        this.availableSizes[size].columns.forEach((column, index) => {
          if (this.formColumns[index]) {
            let formColumn = {...this.formColumns[index], containerClasses: column.containerClasses}
            return this.updateFormColumn(formColumn)
          }
          this.addFormColumns({containerClasses: column.containerClasses})
        })
        if (this.availableSizes[size].columns.length >= this.formColumns.length) {
          return
        }
        let columnsToRemove = this.formColumns.length - this.availableSizes[size].columns.length
        for (let x = 0; x < columnsToRemove; x++) {
          this.removeFormColumn(this.formColumns[this.formColumns.length - 1])
        }
      },
      updateFormColumn(newFormColumn) {
        let rows = Array.from(this.parent.formRows).map(formRow => {
          if (formRow.id != this.id) {
            return formRow
          }
          let columns = formRow.columns.map(formColumn => {
            if (formColumn.id != newFormColumn.id) {
              return formColumn
            }
            return newFormColumn
          })
          return {...formRow, columns: columns}
        })
        this.addToObject(this.module, {rows: rows}, 'content', null, this.formElement, true, this.parentModule)
      },
      addFormColumns(containerClasses) {
        let rows = Array.from(this.parent.formRows).map(formRow => {
          if (formRow.id != this.id) {
            return formRow
          }
          let columns = [...formRow.columns, {...(new FormColumnFactory).create(), ...containerClasses}]
          formRow = {...formRow, columns: columns}
          return formRow
        })
        this.addToObject(this.module, {rows: rows}, 'content', null, this.formElement, true, this.parentModule)
      },
      removeFormColumn(removableformColumn) {
        let rows = Array.from(this.parent.formRows).map(formRow => {
          if(formRow.id != this.id) {
            return formRow
          }
          let columns = formRow.columns.filter(formColumn => formColumn.id != removableformColumn.id)
          return {...formRow, columns: columns}
        })
        this.addToObject(this.module, {rows: rows}, 'content', null, this.formElement, true, this.parentModule)
      },
      removeRow() {
        let element = Array.from(this.parent.formRows).filter(formRow => formRow.id != this.id)
        this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
      },
      // addFormColumn(qty) {
      //   let element = this.newColumn(qty)
      //   this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
      // },
      newColumn(qty) {
        let newColumn = (new FormColumnFactory(qty)).create()
        let rows = Array.from(this.parent.formRows).map(formRow => {
          if (formRow.id != this.id) {
            return formRow
          }
          let columns = [...formRow.columns, newColumn]
          formRow = {...formRow, columns: columns}
          return formRow
        })
        return rows
      }
    }
	}
</script>